import { CheckCircleOutline, FmdBadOutlined } from "@mui/icons-material";
import { Divider, Menu, MenuItem } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import { Box, Typography } from "components";
import PropTypes from "prop-types";
import React from "react";

const notifications = [
  {
    id: 1,
    icon: <CheckCircleOutline fontSize="small" color="success" />,
    text: "Project was created successfully on 25 Sep 2023 at 11:00 a.m.",
  },
  {
    id: 2,
    icon: <FmdBadOutlined color="warning" fontSize="small" />,
    text: "Data upload failed for project on 27 Sep 2023 at 01:00 p.m.",
  },
  {
    id: 3,
    icon: <CheckCircleOutline fontSize="small" color="success" />,
    text: "Model training completed for project with 1000 training samples.",
  },
];

function Notification({ anchorEl = null, open, handleClose }) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      sx={({ palette }) => ({
        "& .MuiMenu-paper": {
          display: "flex",
          flexDirection: "column",
          width: "22%",
          height: "40%",
          mt: pxToRem(30),
          padding: `${pxToRem(8)} ${pxToRem(8)}`,
          overflowY: "scroll",
          border: `1px solid ${palette.grey[300]}`,
          boxShadow: "none",
        },
      })}
    >
      {notifications.map((notification, index) => (
        <Box key={notification.id}>
          <MenuItem
            onClick={handleClose}
            className="flex-display"
            padding={pxToRem(16)}
            key={notification.id}
          >
            <Box
              sx={{
                display: "flex",
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
                gap: pxToRem(8),
              }}
              key={notification.id}
            >
              {notification.icon}
              <Typography variant="inherit">{notification.text}</Typography>
            </Box>
          </MenuItem>
          {index < notifications.length - 1 && (
            <Divider sx={({ palette }) => ({ backgroundColor: palette.grey[500] })} />
          )}
        </Box>
      ))}
    </Menu>
  );
}

Notification.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default Notification;
